import makeApi from 'libs/core/configureAxios'

const api = makeApi(`${process.env.REACT_APP_API_BASE_URL}`)

const getLandingPages = payload => api.get('/platform/landingpages', payload)

const getLandingPageLabels = payload => api.get('/platform/landingpages/labels', payload)

const getLandingPageLabelsById = payload =>
  api.get(`/platform/landingpages/${payload.landingpageTempId}/labels`, { params: payload.params })

const getLandingPageById = payload =>
  api.get(`/platform/landingpages/${payload.landingpageTempId}`, { params: payload.params })

const getLandingPageAddableLabels = payload =>
  api.get(`/platform/landingpages/${payload.landingpageTempId}/label-addable`, {
    params: payload.params,
  })

const getLandingPageHtml = payload =>
  api.get(`/platform/landingpages/${payload.landingpageTempId}/html-replace-url`, {
    params: payload.params,
  })

const createLandingPage = payload =>
  api.post(`/platform/landingpages`, payload.data, { params: payload.params })

const editLandingPage = payload =>
  api.put(`/platform/landingpages`, payload.data, { params: payload.params })

const deleteLandingPage = payload =>
  api.delete(`/platform/landingpages/${payload.landingpageTempId}`, { params: payload.params })

const deleteLandingPageLabel = payload =>
  api.delete(`/platform/landingpages/labels/${payload.labelId}`, { params: payload.params })

const getAddableLandingPages = payload =>
  api.get('/platform/landingpages/addable', { params: payload.params })

const uploadLandingPageImage = payload =>
  api.post('/platform/landingpages/images', payload.data, {
    headers: {
      'content-type': 'multipart/form-data',
    },
    params: payload.params,
  })

export default {
  getLandingPages,
  getLandingPageLabels,
  getLandingPageLabelsById,
  getLandingPageById,
  getLandingPageAddableLabels,
  getLandingPageHtml,
  createLandingPage,
  editLandingPage,
  deleteLandingPage,
  deleteLandingPageLabel,
  getAddableLandingPages,
  uploadLandingPageImage,
}
